<template>
    <WebSocketLoadingModal
        :title="__('tools.testing.tenant.creation.notice')"
        :show-modal="showModal"
        :internal-support-link="internalSupportLink"
        :soft-timeout="180"
        @close="closeModal"
    />
</template>

<script setup>
import { __ } from '~@/Composables/translation'
import WebSocketLoadingModal from '~@/Components/Common/Modals/WebSocketLoadingModal'
import { usePage } from '@inertiajs/vue3'

defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    internalSupportLink: {
        type: String,
        default: () => { return '' }
    }
})

const emit = defineEmits(['closeModal', 'creationDone', 'creationFailed'])

const closeModal = () => {
    emit('closeModal')
}

window.laravelEcho
    .private(`onecrm.tenant.creation.${usePage().props.auth.user.id}`)
    .listen(
        '.tenant.creation_done',
        ({ tenant, newTenant }) => {
            if (tenant !== usePage().props.tenant) {
                return
            }
            emit('creationDone', newTenant)
        }
    )
    .listen(
        '.tenant.creation_failed',
        ({ tenant, error }) => {
            if (tenant !== usePage().props.tenant) {
                return
            }
            emit('creationFailed', error)
        }
    )

</script>
